import React from 'react'
import { InfogramEmbedProps } from './InfogramEmbed.d'
import { Script } from 'gatsby'

const InfogramEmbed = ({
  infogramCaption,
  infogramId,
  infogramTitle
}: InfogramEmbedProps) => {
  return (
    infogramId &&
    infogramTitle && (
      <>
        <div
          className='otl-infogram-embed infogram-embed'
          data-id={infogramId.substring('infogram_0_'.length)}
          data-type='interactive'
          data-title={infogramTitle}
        />
        <Script
          id={infogramId}
        >{`!function(e,i,n,s){var t="InfogramEmbeds",d=e.getElementsByTagName("script")[0];if(window[t]&&window[t].initialized)window[t].process&&window[t].process();else if(!e.getElementById(n)){var o=e.createElement("script");o.async=1,o.id=n,o.src="https://e.infogram.com/js/dist/embed-loader-min.js",d.parentNode.insertBefore(o,d)}}(document,0,"infogram-async");`}</Script>
        {infogramCaption?.infogramCaption && (
          <p className='text-xs font-sansPro leading-[14px]'>
            {infogramCaption.infogramCaption}
          </p>
        )}
      </>
    )
  )
}

export default InfogramEmbed
